import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "float_lock_indicator tag is-warning",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mouse_over=true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mouse_over=false))
  }, [
    _hoisted_1,
    (_ctx.hover)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.timeLeft), 1))
      : _createCommentVNode("", true)
  ], 32))
}